export const resolveCsvFilename = (
  contentDisposition: unknown,
  fallback: string
): string => {
  if (typeof contentDisposition !== "string") {
    return fallback
  }

  const filenameMatch = contentDisposition.match(/filename="([^"]+)"/)
  return filenameMatch?.[1] ?? fallback
}

export const toDownloadPayload = async (
  data: unknown
): Promise<string | Uint8Array<ArrayBuffer>> => {
  if (typeof data === "string") {
    return data
  }

  if (data instanceof Blob) {
    return new Uint8Array(await data.arrayBuffer())
  }

  if (data instanceof ArrayBuffer) {
    return new Uint8Array(data)
  }

  if (data instanceof Uint8Array) {
    return data as Uint8Array<ArrayBuffer>
  }

  return String(data)
}

export function downloadFile(
  data: string | Uint8Array<ArrayBuffer>,
  filename: string,
  mimeType = "application/octet-stream"
) {
  const blob = new Blob([data], { type: mimeType })

  const url = URL.createObjectURL(blob)

  const a = document.createElement("a")
  a.href = url
  a.download = filename

  document.body.appendChild(a)
  a.click()

  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
